import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { BankIntegrationViewContainer } from './BankIntegrationViewContainer';
import { Typography } from 'packages/common-frontend/components/Typography';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { useGetUserOrgCashBalancePreferenceQuery } from '~/core/routes/settings/bank-integrations/requests/getUserOrgCashBalancePreference.gql.generated';

// Fragments
const RouteBase = () => {
  const cashBalancePreferenceQuery = useGetUserOrgCashBalancePreferenceQuery();

  if (cashBalancePreferenceQuery.error) throw cashBalancePreferenceQuery.error;
  if (
    cashBalancePreferenceQuery.loading ||
    !cashBalancePreferenceQuery.data?.user
  ) {
    return <Skeleton />;
  }

  const { user } = cashBalancePreferenceQuery.data;

  if (!user.organization.orgPreferences?.cashBalancePreference) {
    throw Error('Failed to load borrower settings');
  }

  return (
    <BankIntegrationViewContainer
      cashBalancePreference={
        user.organization.orgPreferences.cashBalancePreference
      }
    />
  );
};

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.userType !== 'BORROWER') return 'deny';
  if (context.flags.isBorrowerLimitedOrganization) return 'upsell';
  return 'allow';
};
export const Route = () => (
  <PermissionGuard
    permissions={permissions}
    fallback={<Navigate to="/settings" replace />}
  >
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings" />;
      }}
    >
      <Typography variant="page-title">Bank Integrations</Typography>
      <RouteBase />
    </RouteErrorBoundary>
  </PermissionGuard>
);
